import { render, staticRenderFns } from "./NotesSection.vue?vue&type=template&id=e930b794&scoped=true&"
import script from "./NotesSection.vue?vue&type=script&lang=js&"
export * from "./NotesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e930b794",
  null
  
)

export default component.exports